/* Kaufmodul 032 — Web Component <kaufmodul-032> (immer defer, kein Render-Blocking).
   Rabatt nur zur Anzeige; abgezogen wird er von den automatischen Rabatten in Shopify.
   Daten: <script type="application/json" data-km-config> im Abschnitt. */
(function () {
  'use strict';
  if (window.customElements.get('kaufmodul-032')) return;

  function track(name, data) {
    try { if (window.clarity) window.clarity('event', name); } catch (e) { /* ignore */ }
    try {
      var a = window.Shopify && window.Shopify.analytics;
      if (a && a.publish) a.publish(name, data || {});
    } catch (e) { /* ignore */ }
  }
  function clarityTag(key, value) {
    try { if (window.clarity) window.clarity('set', key, String(value)); } catch (e) { /* ignore */ }
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* Platzhalter %n, %t, %c, %f, %w, %m aus der Sprachdatei ersetzen */
  function fill(tpl, map) {
    return String(tpl || '').replace(/%([a-z])/g, function (_, k) { return map[k] != null ? map[k] : ''; });
  }
  function joinColors(list, and) {
    if (list.length < 2) return list[0] || '';
    return list.slice(0, -1).join(', ') + and + list[list.length - 1];
  }

  var Kaufmodul = function () { return Reflect.construct(HTMLElement, [], Kaufmodul); };
  Kaufmodul.prototype = Object.create(HTMLElement.prototype);
  Kaufmodul.prototype.constructor = Kaufmodul;

  Kaufmodul.prototype.connectedCallback = function () {
    var self = this;
    var cfgEl = this.querySelector('[data-km-config]');
    try { this.cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var cfg = this.cfg;
    this.byHandle = {};
    cfg.colors.forEach(function (c) { self.byHandle[c.handle] = c; });

    this.el = {
      total: this.querySelector('[data-km-total]'),
      ship: this.querySelector('[data-km-ship]'),
      error: this.querySelector('[data-km-error]'),
      btn: this.querySelector('[data-km-add]'),
      mix: this.querySelector('[data-km-mix]'),
      devices: this.querySelector('[data-km-devices]'),
      sticky: this.querySelector('[data-km-sticky]'),
      selection: this.querySelector('[data-km-selection]'),
      more: this.querySelector('[data-km-more]')
    };

    var checked = this.querySelector('[data-km-color]:checked');
    var firstOk = cfg.colors.filter(function (c) { return c.status !== 'sold_out'; })[0];
    this.color = checked ? checked.value : (firstOk ? firstOk.handle : '');
    this.qty = 1;
    this.devices = [this.color];
    this.touched = [false];
    this.mixTracked = false;
    this.busy = false;

    this.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-km-color]')) { self.setColor(t.value); track('kaufmodul_farbe', { farbe: t.value }); }
      else if (t.matches('[data-km-qty]')) { self.setQty(parseInt(t.value, 10) || 1); track('kaufmodul_menge', { anzahl: self.qty }); }
      else if (t.matches('[data-km-device]')) {
        var i = parseInt(t.dataset.index, 10);
        self.devices[i] = t.value; self.touched[i] = true; self.render();
      }
    });
    if (this.el.btn) this.el.btn.addEventListener('click', function () { self.add(); });

    /* Farbwahl von aussen (4-Farben-Bild): Event kaufmodul:farbe mit Produkt-Handle */
    document.addEventListener('kaufmodul:farbe', function (e) {
      var h = e.detail && e.detail.handle;
      var c = self.byHandle[h];
      if (!c || c.status === 'sold_out') return;
      var input = self.querySelector('[data-km-color][value="' + h + '"]');
      if (input) input.checked = true;
      self.setColor(h);
      if (e.detail.source === 'farbbild') track('farbbild_klick', { farbe: h });
    });

    this.initObservers();
    this.render();
  };

  Kaufmodul.prototype.money = function (cents) {
    var amt = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return String(this.cfg.moneyFormat || 'CHF {{amount}}').replace(/\{\{\s*amount\s*\}\}/, amt);
  };
  Kaufmodul.prototype.pct = function (qty) {
    return qty >= 3 ? this.cfg.tier3 : (qty === 2 ? this.cfg.tier2 : 0);
  };
  Kaufmodul.prototype.unit = function (price, qty) {
    return Math.round(price * (100 - this.pct(qty)) / 100);
  };

  Kaufmodul.prototype.setColor = function (handle) {
    var self = this;
    this.color = handle;
    this.devices = this.devices.map(function (d, i) { return self.touched[i] ? d : handle; });
    this.querySelectorAll('[data-kaufmodul-farbe]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    document.querySelectorAll('[data-kaufmodul-farbe]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.kaufmodulFarbe === handle ? 'true' : 'false');
    });
    this.render();
  };
  Kaufmodul.prototype.setQty = function (n) {
    this.qty = Math.max(1, Math.min(n, this.cfg.maxUnits || 3));
    for (var i = 0; i < this.qty; i++) {
      if (!this.devices[i]) { this.devices[i] = this.color; this.touched[i] = false; }
    }
    this.render();
  };

  Kaufmodul.prototype.renderDevices = function () {
    var self = this, cfg = this.cfg;
    if (!this.el.mix || !this.el.devices) return;
    if (this.qty < 2) { this.el.mix.hidden = true; return; }
    this.el.mix.hidden = false;
    var html = '';
    for (var i = 0; i < this.qty; i++) {
      var name = fill(cfg.strings.device, { n: i + 1 });
      html += '<div class="km__device" role="radiogroup" aria-label="' + esc(name) + '"><span class="km__device-name">' + esc(name) + '</span><div class="km__chips">';
      cfg.colors.forEach(function (c) {
        var dis = c.status === 'sold_out';
        html += '<label class="km__chip"><input type="radio" name="km-dev-' + esc(cfg.sectionId) + '-' + i + '" value="' + esc(c.handle) + '" data-km-device data-index="' + i + '"' +
          (self.devices[i] === c.handle ? ' checked' : '') + (dis ? ' disabled' : '') + '>' + esc(c.label) + '</label>';
      });
      html += '</div></div>';
    }
    this.el.devices.innerHTML = html;
  };

  /* Pro Farbe: sofort = min(Anzahl, Lager), Rest folgt später */
  Kaufmodul.prototype.counts = function () {
    var counts = {}, self = this;
    this.devices.slice(0, this.qty).forEach(function (h) { counts[h] = (counts[h] || 0) + 1; });
    return Object.keys(counts).map(function (h) {
      var c = self.byHandle[h], n = counts[h];
      var stock = c.tracked ? Math.max(c.inventoryQuantity, 0) : n;
      var now = Math.min(n, stock);
      return { c: c, n: n, now: now, later: n - now };
    });
  };

  /* Versandtag («am Donnerstag») kommt aus theme.js (Versandhinweis der Produktseite) */
  Kaufmodul.prototype.shipDay = function () {
    return document.documentElement.dataset.shipDay || this.cfg.strings.shipNextWorkday;
  };
  Kaufmodul.prototype.shipText = function (rows) {
    var s = this.cfg.strings, self = this, day = this.shipDay();
    var later = rows.filter(function (r) { return r.later > 0; });
    if (!later.length) {
      var note = this.querySelector('[data-km-shipnow] [data-ship-note], [data-km-shipnow] .pdp__stock');
      return (note && note.textContent.trim()) || s.shipNow;
    }
    var when = later[0].c.preorderWhen || '';
    var allLater = rows.every(function (r) { return r.now === 0; });
    if (allLater) return later[0].c.preorderNote || s.preorderDefault;
    var partial = rows.filter(function (r) { return r.now > 0 && r.later > 0; });
    if (partial.length) {
      return partial.map(function (r) {
        return fill(r.later === 1 ? s.shipPartialOne : s.shipPartialMany, { d: day, n: r.now, m: r.later, f: r.c.label, w: r.c.preorderWhen || when });
      }).join(' ');
    }
    var names = later.map(function (r) { return r.n > 1 ? r.n + ' × ' + r.c.label : r.c.label; });
    var total = later.reduce(function (a, r) { return a + r.later; }, 0);
    return fill(total === 1 ? s.shipMixedOne : s.shipMixedMany, { d: day, f: joinColors(names, s.and), w: when });
  };

  Kaufmodul.prototype.render = function () {
    var self = this, s = this.cfg.strings;
    this.renderDevices();
    /* Link zur Produktseite der gewählten Farbe («Mehr Bilder von Schwarz ansehen») */
    var cur = this.byHandle[this.color];
    if (this.el.more && cur && cur.url) {
      this.el.more.href = cur.url;
      this.el.more.textContent = fill(s.moreImages, { f: cur.label });
      this.el.more.hidden = false;
    }
    var list = this.devices.slice(0, this.qty);
    var full = 0, disc = 0;
    list.forEach(function (h) { var p = self.byHandle[h].price; full += p; disc += self.unit(p, self.qty); });
    if (this.el.total) {
      /* «Total X statt Y»: Teil ab dem Streichpreis in eine eigene Zeile */
      var tpl = esc(disc < full ? s.totalCompare : s.total), cut = tpl.indexOf('%t') + 2;
      this.el.total.innerHTML = '<span>' + fill(tpl.slice(0, cut), { t: '<strong>' + this.money(disc) + '</strong>' }) + '</span>' +
        (disc < full ? '<span class="km__total-cmp">' + fill(tpl.slice(cut), { c: '<s>' + this.money(full) + '</s>' }) + '</span>' : '');
    }
    var rows = this.counts();
    if (this.el.ship) this.el.ship.textContent = this.shipText(rows);
    if (this.el.selection) {
      var names = rows.map(function (r) { return (r.n > 1 ? r.n + ' × ' : '') + r.c.label; });
      this.el.selection.textContent = this.qty === 1
        ? fill(s.selectionOne, { f: names[0] })
        : fill(s.selectionMany, { n: this.qty, f: joinColors(names, s.and) });
    }
    this.total = disc;
    var distinct = list.filter(function (h, i) { return list.indexOf(h) === i; });
    if (distinct.length > 1 && !this.mixTracked) { this.mixTracked = true; track('kaufmodul_mix', { farben: distinct.join(',') }); }
  };

  Kaufmodul.prototype.showError = function (msg) {
    if (!this.el.error) return;
    this.el.error.textContent = msg; this.el.error.hidden = !msg;
  };
  Kaufmodul.prototype.setBusy = function (on) {
    this.busy = on;
    var b = this.el.btn; if (!b) return;
    b.disabled = on; b.setAttribute('aria-busy', on ? 'true' : 'false');
    b.textContent = on ? b.dataset.labelBusy : b.dataset.label;
  };

  Kaufmodul.prototype.add = function () {
    var self = this, s = this.cfg.strings, cfg = this.cfg;
    if (this.busy) return;
    this.showError('');
    var rows = this.counts();
    /* Lager nur bei Policy DENY begrenzen */
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      if (r.c.inventoryPolicy === 'deny' && r.c.tracked && r.n > Math.max(r.c.inventoryQuantity, 0)) {
        this.showError(fill(s.errorStock, { f: r.c.label, n: Math.max(r.c.inventoryQuantity, 0) }));
        track('kaufmodul_fehler', { grund: 'lager' });
        return;
      }
    }
    this.setBusy(true);
    var items = rows.map(function (r) {
      return { id: r.c.variantId, quantity: r.n, properties: { _quelle: 'kaufmodul-' + cfg.sourceTag } };
    });
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) throw new Error('status ' + res.status);
      track('kaufmodul_warenkorb', {
        anzahl: self.qty,
        farben: rows.map(function (r) { return r.c.handle; }).join(','),
        total_chf: (self.total / 100).toFixed(2)
      });
      clarityTag('kaufmodul', 'ja');
      /* Kein Cart-Drawer im Theme → Warenkorbseite */
      window.location.href = cfg.cartUrl || (root + 'cart');
    }).catch(function (err) {
      track('kaufmodul_fehler', { grund: String(err && err.message || 'fetch') });
      /* Echten Warenkorbstand nachladen (Zähler im Header) */
      fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var bubble = document.querySelector('.cart-bubble');
        if (!bubble) return;
        var count = bubble.querySelector('.cart-bubble__count');
        if (cart.item_count > 0) {
          if (!count) { count = document.createElement('span'); count.className = 'cart-bubble__count'; bubble.appendChild(count); }
          count.textContent = cart.item_count;
        } else if (count) { count.remove(); }
      }).catch(function () { /* ignore */ });
      self.showError(s.errorGeneric);
      self.setBusy(false);
    });
  };

  Kaufmodul.prototype.initObservers = function () {
    var self = this;
    if (!('IntersectionObserver' in window)) return;
    /* Sichtbarkeit: einmal pro Seitenaufruf ab 50 % */
    var seen = false;
    new IntersectionObserver(function (en, obs) {
      if (seen || !en[0].isIntersecting) return;
      seen = true; obs.disconnect();
      track('kaufmodul_sichtbar', { source_tag: self.cfg.sourceTag });
    }, { threshold: 0.5 }).observe(this);

    /* Sticky-Leiste (nur Handy): Modul nach oben weg → sichtbar; Modul oder Footer im Bild → weg */
    var sticky = this.el.sticky;
    if (!sticky) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var above = false, footerIn = false;
    var sync = function () {
      var on = mq.matches && above && !footerIn;
      sticky.hidden = false;
      sticky.classList.toggle('is-visible', on);
      document.body.classList.toggle('km-sticky-on', on);
    };
    new IntersectionObserver(function (en) {
      var e = en[0];
      above = !e.isIntersecting && e.boundingClientRect.bottom < 0;
      sync();
    }).observe(this);
    var footer = document.querySelector('.footer, footer');
    if (footer) new IntersectionObserver(function (en) { footerIn = en[0].isIntersecting; sync(); }).observe(footer);
    if (mq.addEventListener) mq.addEventListener('change', sync);
    var btn = sticky.querySelector('[data-km-sticky-btn]');
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      track('sticky_klick');
      self.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  window.customElements.define('kaufmodul-032', Kaufmodul);
})();
